import type { IShapeData } from '@tencent/slide-sdk-model';
import { calcTextRect } from './calc-text-rect';

/**
 * TODO:
 * 不同字体的半角字符宽度可能不同
 */
const halfWidthRatio = 0.75;
// const halfWidthRatio = 0.5;

export function measureText(
  text: string,
  fontSize: number,
  letterSpacing: number,
  lineHeight: number,
  maxWidth: number,
) {
  let fullWidthCount = 0;
  let halfWidthCount = 0;
  let lines = 1;
  let maxWidthReached = false;
  let maxWidthLine = '';
  let maxWidthWidth = 0;
  let currentLine = '';
  let widthInOneLine = 0;
  let t = {
    get currentLine() {
      return currentLine;
    },
    set currentLine(val) {
      if (val === undefined) debugger;
      currentLine = val;
    },
  };
  let currentWidth = 0;
  for (let i = 0; i < text.length; i++) {
    const charCode = text.charCodeAt(i);
    if (charCode === 10) {
      // 换行符
      lines++;
      if (currentWidth > maxWidthWidth) {
        maxWidthLine = t.currentLine;
        maxWidthWidth = currentWidth;
      }
      t.currentLine = '';
      currentWidth = 0;
      continue;
    }
    let deltaW = 0;
    // 判断字符是否为全角字符
    // FIXME: 范围误差较大
    if (charCode >= 127) {
      fullWidthCount++;
      deltaW = fontSize + letterSpacing;
    } else {
      halfWidthCount++;
      deltaW = fontSize * halfWidthRatio + letterSpacing;
    }
    widthInOneLine += deltaW;
    if (currentWidth + deltaW > maxWidth) {
      maxWidthReached = true;
      if (t.currentLine.length > 0) {
        lines++;
        maxWidthLine = t.currentLine;
        maxWidthWidth = currentWidth;
        t.currentLine = text[i];
        currentWidth = deltaW;
      } else {
        lines++;
        maxWidthLine = text[i];
        maxWidthWidth = deltaW;
        (t.currentLine = ''), (currentWidth = 0);
      }
    } else {
      currentWidth += deltaW;
      t.currentLine += text[i];
    }
  }
  if (currentWidth > maxWidthWidth) {
    maxWidthLine = t.currentLine;
    maxWidthWidth = currentWidth;
  }

  // 计算文本总长度和总高度
  const fullWidthLength = fullWidthCount * (fontSize + letterSpacing);
  const halfWidthLength = halfWidthCount * (fontSize * halfWidthRatio + letterSpacing);
  const totalWidth = Math.max(maxWidthWidth, currentWidth);
  const totalHeight = lines * lineHeight;

  return {
    fullWidthCount,
    halfWidthCount,
    totalWidth,
    totalHeight,
    maxWidthReached,
    maxWidthLine,
    linesCount: lines,
    widthInOneLine,
    fontSize,
  };
}

export const EMU_PER_POINT = 12700;
export const POINT_PER_EMU = 1 / EMU_PER_POINT;

export const canShapeContainsText = (shapeData: IShapeData, text: string, adjust = false) => {
  const { width, height } = calcTextRect(shapeData.spPr);
  const firstParagraph = shapeData.txBody?.p?.[0]!;
  // if (!width || !firParagraph) return Number.POSITIVE_INFINITY;

  // TODO:
  const { bIns = 46800, tIns = 46800, lIns = 90000, rIns = 90000 } = shapeData.txBody!.bodyPr ?? {};
  const { marL = 0, marR = 0 } = firstParagraph.pPr ?? {};
  const availableWidth = (width - lIns - rIns - marL - marR) * POINT_PER_EMU;
  const availableHeight = (height - bIns - tIns) * POINT_PER_EMU;

  // 默认 fontSize 18pt
  const fontSize = (firstParagraph.egTextRun?.[0]?.r?.rPr?.sz ?? 1800) / 100;
  const letterSpacing = (firstParagraph.egTextRun?.[0]?.r?.rPr?.spc ?? 0) / 100;
  // 默认 1.3 倍行距
  const lnSpc = shapeData.txBody?.p?.[0]?.pPr?.lnSpc ?? { spcPct: { val: 130000 } };

  const calcLineHeight = (fontSize: number) => {
    const PERCENT_LINE_HEIGHT_SLIDE_TO_PPT_RATIO = 1.2;

    if (lnSpc.spcPct?.val) {
      return (lnSpc.spcPct.val / 100000) * fontSize * PERCENT_LINE_HEIGHT_SLIDE_TO_PPT_RATIO;
    }
    if (lnSpc.spcPts?.val) {
      return lnSpc.spcPts.val / 100;
    }
    return fontSize;
  };

  // 需要拆两个函数，一个只管测量，且默认按缩放（即-2）算
  // 另一个算合适的 fontSize
  if (!adjust) {
    let measureFontSize = fontSize - 2;
    const res = measureText(text, measureFontSize, letterSpacing, calcLineHeight(measureFontSize), availableWidth);
    const canContains = res.totalHeight <= availableHeight + 5; /** 容错阈值 */
    return {
      result: canContains,
      detail: res,

      fontSize,
      expectFontSize: measureFontSize,
    };
  }

  let expectFontSize = fontSize;
  let res = measureText(text, expectFontSize, letterSpacing, calcLineHeight(expectFontSize), availableWidth);
  let canContains = res.totalHeight <= availableHeight + 5; /** 容错阈值 */

  if (!canContains) {
    // measure again
    expectFontSize -= 2;
    res = measureText(text, expectFontSize, letterSpacing, calcLineHeight(expectFontSize), availableWidth);
    canContains = res.totalHeight <= availableHeight + 5; /** 容错阈值 */
  }
  if (!canContains) {
    const ratio = Math.max(Math.min(res.widthInOneLine / res.totalWidth, 2), 1);
    expectFontSize = Math.floor(fontSize / ratio);
  }

  return {
    result: canContains,
    detail: res,

    fontSize,
    expectFontSize,
  };
};
